// Google Analytics 4 tracking utilities

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// Track "Get Started" button clicks
export const trackGetStartedClick = (buttonLocation = 'unknown') => {
  if (isGtagAvailable()) {
    window.gtag('event', 'get_started_click', {
      event_category: 'engagement',
      event_label: buttonLocation,
      button_location: buttonLocation,
      timestamp: new Date().toISOString()
    });
    
    console.log('GA4 Event: get_started_click', { button_location: buttonLocation });
  } else {
    console.warn('Google Analytics not available');
  }
};

// Track purchase completion
export const trackPurchaseCompleted = (planData) => {
  if (isGtagAvailable()) {
    const {
      planName,
      price,
      isAnnual = false,
      currency = 'USD'
    } = planData;

    // GA4 Enhanced Ecommerce purchase event
    window.gtag('event', 'purchase', {
      transaction_id: `txn_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      value: price,
      currency: currency,
      items: [{
        item_id: planName.toLowerCase().replace(/\s+/g, '_'),
        item_name: planName,
        item_category: 'subscription',
        item_variant: isAnnual ? 'annual' : 'monthly',
        price: price,
        quantity: 1
      }]
    });

    // Custom purchase_completed event with additional parameters
    window.gtag('event', 'purchase_completed', {
      event_category: 'ecommerce',
      event_label: planName,
      item_name: planName,
      price: price,
      plan: planName,
      billing_cycle: isAnnual ? 'annual' : 'monthly',
      currency: currency,
      timestamp: new Date().toISOString()
    });

    console.log('GA4 Events: purchase & purchase_completed', {
      item_name: planName,
      price: price,
      plan: planName,
      billing_cycle: isAnnual ? 'annual' : 'monthly'
    });
  } else {
    console.warn('Google Analytics not available');
  }
};

// Track general custom events
export const trackCustomEvent = (eventName, parameters = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', eventName, {
      ...parameters,
      timestamp: new Date().toISOString()
    });
    
    console.log(`GA4 Event: ${eventName}`, parameters);
  } else {
    console.warn('Google Analytics not available');
  }
};

// Track page views (useful for SPA navigation)
export const trackPageView = (pagePath, pageTitle) => {
  if (isGtagAvailable()) {
    window.gtag('config', 'G-WQVC3489DM', {
      page_path: pagePath,
      page_title: pageTitle
    });
    
    console.log('GA4 Page View:', { page_path: pagePath, page_title: pageTitle });
  } else {
    console.warn('Google Analytics not available');
  }
};

// Track form submissions
export const trackFormSubmission = (formName, formData = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', 'form_submit', {
      event_category: 'engagement',
      event_label: formName,
      form_name: formName,
      ...formData,
      timestamp: new Date().toISOString()
    });
    
    console.log('GA4 Event: form_submit', { form_name: formName, ...formData });
  } else {
    console.warn('Google Analytics not available');
  }
};

// Track email signups
export const trackEmailSignup = (source = 'unknown') => {
  if (isGtagAvailable()) {
    window.gtag('event', 'sign_up', {
      method: 'email',
      event_category: 'engagement',
      event_label: source,
      signup_source: source,
      timestamp: new Date().toISOString()
    });
    
    console.log('GA4 Event: sign_up', { signup_source: source });
  } else {
    console.warn('Google Analytics not available');
  }
};

// Track signup completion (for success page)
export const trackSignupCompleted = (signupData = {}) => {
  if (isGtagAvailable()) {
    const {
      plan = 'free',
      email = '',
      name = ''
    } = signupData;

    // GA4 sign_up event
    window.gtag('event', 'sign_up', {
      method: 'email',
      event_category: 'conversion',
      event_label: plan,
      plan: plan,
      has_email: !!email,
      has_name: !!name,
      timestamp: new Date().toISOString()
    });

    // Custom signup_completed event
    window.gtag('event', 'signup_completed', {
      event_category: 'conversion',
      event_label: plan,
      plan: plan,
      signup_method: 'email',
      has_email: !!email,
      has_name: !!name,
      timestamp: new Date().toISOString()
    });

    console.log('GA4 Events: sign_up & signup_completed', {
      plan: plan,
      has_email: !!email,
      has_name: !!name
    });
  } else {
    console.warn('Google Analytics not available');
  }
};